import styled, { keyframes } from 'styled-components'
import { MarginsProps, getMargin } from '../helpers/styleHelpers'

export const Rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

type Props = {
  color?: string
  size?: number
  center?: boolean
} & MarginsProps

const LoadingIndicator = styled('div')<Props>`
  ${props => (props.center ? 'margin: 0 auto' : '')};
  width: ${props => (props.size ? `${props.size}px` : '16px')};
  height: ${props => (props.size ? `${props.size}px` : '16px')};
  position: relative;
  ${getMargin};
  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    border: 2px solid ${props => (props.color ? props.color : '#fff')};
    width: 80%;
    height: 80%;
    border-top-color: transparent;
    border-right-color: transparent;
    animation: ${Rotate360} 500ms infinite linear;
    border-radius: 50%;
  }
`

export default LoadingIndicator
